const BASE_PATH = process.env.REACT_APP_BASE_URL || '/intelligentResolver';
const ENABLE_IMAGE_PROXY = (process.env.REACT_APP_ENABLE_IMAGE_PROXY ?? 'true') !== 'false';

export const isImageProxyEnabled = ENABLE_IMAGE_PROXY;
export const imageProxyBasePath = BASE_PATH;

export const withImageProxy = (url?: string | null) => {
    if (!url) return url || '';
    if (!ENABLE_IMAGE_PROXY) return url;
    if (url.includes('/image-proxy?url=')) return url;
    if (url.startsWith('data:') || url.startsWith('blob:')) return url;

    const proxyPath = `${BASE_PATH}/image-proxy?url=${encodeURIComponent(url)}`;

    if (typeof window !== 'undefined' && window.location?.origin) {
        const origin = window.location.origin.replace(/\/$/, '');
        return `${origin}${proxyPath}`;
    }

    return proxyPath;
};

